import React from 'react';
import DotBadge from "components/DotBadge";

function batteryLevelColor(batteryLevel?: number | undefined): number {
    if(typeof batteryLevel !== 'number'){
        return DotBadge.colors.GRAY
    }

    if(batteryLevel <= 20){
        return DotBadge.colors.RED
    }

    if(batteryLevel <= 30){
        return DotBadge.colors.YELLOW
    }

    if(batteryLevel >= 70){
        return DotBadge.colors.GREEN
    }

    return DotBadge.colors.GRAY
}

type Props = {
    percent: number
}

function BatteryLevel({percent}: Props) {
    return (
        <DotBadge color={batteryLevelColor(percent)} text={`${percent}%`} />
    );
}

BatteryLevel.defaultProps = {
    levelPercent: 0
}

export default BatteryLevel;